import React, { useRef } from "react";
import JoditEditor from "jodit-react";

const Quill = ({ setContent, editorContent, editorError, setEditorError }) => {
  const editor = useRef(null);

  const config = {
    readonly: false,
    placeholder: "Start typing...",
    toolbarAdaptive: false,
    removeButtons: [
      "print",
      "font",
      "fontsize",
      "brush",
      "image",
      "file",
      "video",
      "about",
      "className",
      "paint",
      "lineHeight",
      "classSpan",
      "spellcheck",
      "copyformat",
      "ai-assistant",
      "ai-commands",
    ],
  };

  const handleEditorBlur = (newContent) => {
    if (!newContent.trim() || newContent === "<p><br></p>") {
      setEditorError("This field is required.");
    } else {
      setEditorError(""); // Clear error if content is valid
    }

    setContent(newContent); // Pass content to parent component
  };

  return (
    <div className="editor_our">
      <JoditEditor
        ref={editor}
        value={editorContent}
        config={config}
        tabIndex={1}
        onBlur={handleEditorBlur} // Handle blur
      />
      {editorError && <span style={{ color: "red" }}>{editorError}</span>}
    </div>
  );
};

export default Quill;
